import React, { useState } from 'react';
import { useDetectClickOutside } from 'react-detect-click-outside';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  routes,
} from 'consts';
import {
  EnelXGuiAtoms, EnelXGuiComponents, EnelXGuiConsts, EnelXGuiUtils,
} from 'gui';

import {
  MenuElement, MenuLabel, SidebarStyle,
} from 'components/navbar/Navbar-styles';

const {
  MigrationButton,
  MigrationIcon,
} = EnelXGuiAtoms;

const {
  MigrationMainSidebar,
} = EnelXGuiComponents;

const {
  COLOR_PRIMARY_BASE,
  PAGES_SIDEBAR_ID,
} = EnelXGuiConsts;

const {
  getDsyTokenValue,
} = EnelXGuiUtils;

function Sidebar() {
  const { t } = useTranslation();

  const primaryColor = getDsyTokenValue(COLOR_PRIMARY_BASE);

  const [showMenu, setShowMenu] = useState(false);

  const ref = useDetectClickOutside({
    onTriggered: () => setShowMenu(false),
  });

  const entries = () => [
    {
      type: 'simple',
      title: 'navigation.homepage',
      icon: (
        <span style={{ marginLeft: '3px' }}>
          <MigrationIcon
            name="desktop"
            size="25px"
          />
        </span>
      ),
      link: routes.dashboard.root,
    },
    {
      type: 'simple',
      title: 'navigation.energyCommunity',
      icon: <MigrationIcon
        name="solar-panel"
        size="30px"
      />,
      link: routes.energyCommunity.root,
    },
  ];

  const [showChildren, setShowChildren] = useState({
    sessions: false,
    users: false,
    finances: false,
    groups: false,
    help: false,
  });

  const resetChildrenState = () => {
    setShowChildren({
      sessions: false,
      users: false,
      finances: false,
      groups: false,
      help: false,
    });
  };

  const toggleSidebar = () => {
    setShowMenu(false);
    resetChildrenState();
  };

  const menuEntry = ({
    title, icon, link,
  }) => (true ? (
    <Link
      style={{ textDecoration: 'none' }}
      href={link}
      to={link}
      onClick={() => {
        resetChildrenState();
        setShowMenu(false);
      }}
    >
      <MenuElement color={primaryColor}>
        {icon}
        <MenuLabel>{ t(title) }</MenuLabel>
      </MenuElement>
    </Link>
  ) : null);

  const subMenuEntry = (title, link, showSub) => (true ? ( // restore this if rolebase is needed, isRouteAvailable(link)
    <Link
      style={{ textDecoration: 'none' }}
      href={link}
      to={link}
      onClick={() => {
        resetChildrenState();
        setShowMenu(false);
      }}
      key={`${title}@${link}`}
    >
      <div className={showSub ? 'subMenuEntry-active' : 'subMenuEntry-deactive'}>
        <p>{ t(title) }</p>
      </div>
    </Link>
  ) : null);

  const nestedMenuEntry = ({
    title, icon, sublist, id, iconSize,
  }) => (
    <span key={`NESTEDMENUENTRY@-${title}`}>
      <MenuElement
        color={primaryColor}
        onClick={() => { setShowChildren({ ...showChildren, [id]: !showChildren[id] }); }}
      >
        <MigrationIcon
          name={icon}
          size={iconSize ?? '1.2em'}
        />
        <MenuLabel>{ t(title) }</MenuLabel>
        <MigrationButton
          iconName={showChildren[id] ? 'arrow-up' : 'arrow-down'}
          btnType="link"
          style={{ position: 'absolute', right: '.5em' }}
        />
      </MenuElement>
      {
        sublist.map((el) => (
          <React.Fragment
            key={`NESTEDSUBMENU@-${el.title}-${el.link}`}
          >
            {subMenuEntry(el.title, el.link, showChildren[id] === true)}
          </React.Fragment>
        ))
      }
    </span>
  );

  const render = () => (
    <SidebarStyle>
      {
        entries().map((el) => {
          const {
            type, title, icon, link,
          } = el;
          return (
            <React.Fragment key={`${type}-${title}-${link}`}>
              { (type === 'simple' && title && icon && link)
                ? menuEntry(el) : null }
              { (type === 'nested'
              && title
              && icon
              // && sublist.findIndex((subElem) => true) !== -1
              )
                ? nestedMenuEntry(el) : null }
            </React.Fragment>
          );
        })
      }
    </SidebarStyle>
  );

  return (
    <div ref={ref}>
      <MigrationButton
        onClick={() => setShowMenu(!showMenu)}
        iconName="hamburger"
        btnType="secondary"
        iconSize="1em"
        buttonStyle="height: 2.7rem"
        btnSize="compact"
      />
      <MigrationMainSidebar
        close={toggleSidebar}
        defaultHeaderContent={false}
        id={PAGES_SIDEBAR_ID}
        isShown={showMenu}
        noDefaultInternalPadding
        render={render}
        top="64px"
        width="18rem"
      />
    </div>
  );
}

export default Sidebar;
